import { useCallback, useEffect, useState } from "react";
import { Check, fetchCheckList } from "../api/check";
import { getApiErrorMessage } from "../utils/getApiErrorMessage";

export const useCheckList = (enabled = true) => {
  const [data, setData] = useState<Check[]>([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);
  const [reloadToken, setReloadToken] = useState(0);

  const refetch = useCallback(() => {
    setReloadToken((token) => token + 1);
  }, []);

  const applySavedCheck = useCallback((check: Check) => {
    if (!check.id) {
      return;
    }

    setData((current) => {
      const index = current.findIndex((item) => item.id === check.id);
      if (index === -1) {
        return [...current, check];
      }

      const next = [...current];
      next[index] = check;
      return next;
    });
  }, []);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchCheckList()
      .then((items) => {
        if (!cancelled) {
          setData(items);
        }
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(getApiErrorMessage(err, "Не удалось загрузить проверки"));
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, reloadToken]);

  return { data, loading, error, refetch, applySavedCheck };
};
